// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';
import { hidden, visible } from 'utils/node';

export default component((node) => {
  const { modal } = choozy(node);
  const { isMobile } = window.theme;

  const showModal = () => {
    visible(modal);
  };

  const hideModal = () => {
    hidden(modal);
  };

  if (!isMobile) {
    node.addEventListener('mouseenter', showModal);
    node.addEventListener('mouseleave', hideModal);
  }
});
